import { render, staticRenderFns } from "./_base-short-info-box.vue?vue&type=template&id=d7df8fc6&scoped=true"
import script from "./_base-short-info-box.vue?vue&type=script&lang=js"
export * from "./_base-short-info-box.vue?vue&type=script&lang=js"
import style0 from "./_base-short-info-box.vue?vue&type=style&index=0&id=d7df8fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7df8fc6",
  null
  
)

export default component.exports